import { createFileRoute } from '@tanstack/react-router'

import { ListaCadastros } from '@/components/cadastros/ListaCadastros'

export const Route = createFileRoute('/_auth/cadastros')({ component: ListaCadastros })
